import { r } from "./register-DlpCFO7x.js";
import { S as a } from "./register-DlpCFO7x.js";
r();
export {
  a as StatusMessage
};
